import axios from 'axios';
import {
    requestHandler,
    requestErrorHandler,
    responseHandler,
    responseErrorHandler,
} from './handlers';

export const instance = axios.create();

export const initiateInterceptor = store => {
    // request interceptor
    instance.interceptors.request.use(
        request => requestHandler(request, store),
        error => requestErrorHandler(error, store),
    );

    // response interceptor
    instance.interceptors.response.use(
        response => responseHandler(response, store),
        error => responseErrorHandler(error, store),
    );
};

export default instance;
